import { useParams } from 'react-router-dom'

import { useDetails, useFocusMap } from '../map/hooks'

import PrintMap from '../map/components/PrintMap'

import './css/control.css'
import './css/mym-print.css'
import './cssom/contact-buttons.css'
import './cssom/info-cards-style-1.css'

import { BASE_URL } from '../constants'

const MAP_ID = 'detailsMap'

const DetailsPage = () => {
  const { pin } = useParams()
  const [
    { parcel, elementarySchool, middleSchool, highSchool, floodZone, evacuationZone, stormwaterEasement, municipality },
    isLoading
  ] = useDetails(pin)
  //const [{ parcelData, elementarySchool, middleSchool, highSchool, floodZone, evacuationZone, isLoading }] = useParcelData(pin)
  useFocusMap(MAP_ID, parcel && parcel.geometry)
  
  return (
    <>
    <section className="print--banner"> <span>Property Print Preview</span><button className="print--button" onClick={() => window.print()}>Print</button></section>
      <main className="print">
        <header className="print--header">
          <div className="print--logo">
            <img src={`${BASE_URL}images/HC-circle-icon.svg`} alt="HC Connect Icon" />
            <span>Horry County Government</span>
          </div>
        </header>
        <h1 className="print--title">Map Your Move</h1>
        <PrintMap id={MAP_ID} />
        {isLoading.parcel 
          ? <div className="map--layer-loading">
          <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
          <div className="lds-label">...loading</div>
        </div>
          : <>
              <dl className="print--important"> 
                <dt>Owner Info</dt>
                    <dd>{parcel && parcel.attributes.OwnerName}</dd>
                    <dd>{parcel && parcel.attributes.OwnerStreet}<br/>
                        {parcel && parcel.attributes.OwnerCity}, {parcel && parcel.attributes.OwnerState} {parcel && parcel.attributes.OwnerZip}</dd>
                    
                </dl>
              <dl className="print--important"> 
                <dt>Property Info</dt>

                    <dd><span>Pin&thinsp;:</span>{pin}</dd>
                    <dd><span>Legal description&thinsp;:</span> 
                      <span>{parcel && parcel.attributes.LegalDescr}</span>
                  </dd>
                </dl>
              <dl className="print--important"> 
                <dt>School District</dt>
                  <dd><span>Elementary&thinsp;:</span> {isLoading.elementarySchool ? <span className="loading">LOADING...</span> : elementarySchool}</dd>
                  <dd><span>Middle&thinsp;:</span> {isLoading.middleSchool ? <span className="loading">LOADING...</span> : middleSchool}</dd>
                  <dd><span>High School&thinsp;:</span> {isLoading.highSchool ? <span className="loading">LOADING...</span> : highSchool}</dd>
                </dl>
              <div className="print--important"><span>FEMA Flood Zone&thinsp;:</span>{isLoading.floodZone ? <span className="loading">LOADING...</span> : floodZone}</div>
              <div className="print--important"><span>Evacuation Zone&thinsp;:</span>{isLoading.evacuationZone ? <span className="loading">LOADING...</span> : evacuationZone}</div>
              <div className="print--important"><span>Stormwater Easement&thinsp;:</span>{isLoading.stormwaterEasement ? <span className="loading">LOADING...</span> : stormwaterEasement}</div>
              <div className="print--important"><span>Municipality&thinsp;:</span>{isLoading.municipality ? <span className="loading">LOADING...</span> : municipality}</div>
              <div className="print--important"><span>Tax District&thinsp;:</span>{parcel && parcel.attributes.TaxDistrict}</div>
              <h6>DISCLAIMER***</h6>
              <p>The data presented in this application is provided "as is" without warranty or any representation of accuracy, timeliness or completeness. The burden for determining accuracy, completeness, timeliness, and fitness for or the appropriateness for use rests solely on the user. Horry County makes no warranties, express or implied, as to the use of the data. There are no implied warranties or warranties of fitness for a particular purpose or merchantability, and Horry County shall have no liability for actual or consequential losses arising from use of the data. The Land Record data and mapping application represent the parcel fabric as used for taxing purposes and not for survey purposes.</p>
            </>
        }
      </main>
     
    </>
  )
}

export default DetailsPage